import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.taskTypesStatuses.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.taskTypesStatuses.actionsLoading;
export const getItems = (state:RootState) => state.taskTypesStatuses.items;
export const getItemsCount = (state:RootState) => state.taskTypesStatuses.itemsCount;
export const getItemsSelect = (state:RootState) => state.taskTypesStatuses.dropDownItems;
export const getItemForEdit = (state:RootState) => state.taskTypesStatuses.itemForEdit;
export const getError = (state:RootState) => state.taskTypesStatuses.error;
export const getErrorAction = (state:RootState) => state.taskTypesStatuses.errorAction;
export const validationErrors = (state:RootState) => state.taskTypesStatuses.validationErrors;
